<div [formGroup]="formGroup">
  @for (trigger of triggerFormArray.controls; track trigger; let i = $index) {
    <div class="row-container" [formArrayName]="formArrayName">
      <ng-container [formGroupName]="i">
        <div class="field-container">
          <app-autocomplete-field
            [icon]="'notification_important'"
            [label]="sysText.trigger"
            [control]="trigger.controls.trigger"
            [options]="triggerOptions"
            [showSearchIcon]="true">
          </app-autocomplete-field>
          <div class="small-field-group-container">
            @if (trigger.controls.showBusinessDaysBefore.value) {
              <app-input-field
                [control]="trigger.controls.businessDaysBefore"
                [hideIconSpace]="true"
                [label]="sysText.businessDaysBefore"
                [inputType]="'number'">
              </app-input-field>
            }
            @if (trigger.controls.showBusinessDaysAfter.value) {
              <app-input-field
                [hideIconSpace]="true"
                [control]="trigger.controls.businessDaysAfter"
                [label]="sysText.businessDaysAfter"
                [inputType]="'number'">
              </app-input-field>
            }
            @if (trigger.controls.showCalendarDaysBefore.value) {
              <app-input-field
                [control]="trigger.controls.calendarDaysBefore"
                [hideIconSpace]="true"
                [label]="sysText.calendarDaysBefore"
                [inputType]="'number'">
              </app-input-field>
            }
            @if (trigger.controls.showCalendarDaysAfter.value) {
              <app-input-field
                [control]="trigger.controls.calendarDaysAfter"
                [hideIconSpace]="true"
                [label]="sysText.calendarDaysAfter"
                [inputType]="'number'">
              </app-input-field>
            }
          </div>
          @if (trigger.controls.showCaseTimespanGreaterThanDays.value) {
            <app-input-field
              [control]="trigger.controls.caseTimespanGreaterThanDays"
              [label]="sysText.caseTimespanGreaterThanDays"
              [inputType]="'number'">
            </app-input-field>
          }
          @if (trigger.controls.showCaseTimespanLessThanDays.value) {
            <app-input-field
              [control]="trigger.controls.caseTimespanLessThanDays"
              [label]="sysText.caseTimespanLessThanDays"
              [inputType]="'number'">
            </app-input-field>
          }
          @if (trigger.controls.showCaseTimespanMidpoint.value) {
            <app-slide-toggle
              class="left-margin"
              [control]="trigger.controls.caseTimespanMidpoint"
              [label]="sysText.caseTimespanMidpoint">
            </app-slide-toggle>
          }
          @if (trigger.controls.showOtherActionItem.value) {
            <app-autocomplete-field
              class="left-margin"
              [label]="sysText.otherActionItem"
              [control]="trigger.controls.otherActionItem"
              [options]="otherActionItemOptions"
              [showSearchIcon]="true">
            </app-autocomplete-field>
          }
        </div>
        <div>
          @if (triggerFormArray.controls.length > 1) {
            <button
              type="button"
              mat-icon-button
              [attr.aria-label]="sysText.remove_ariaLabel"
              [disableRipple]="true"
              (click)="removeTriggerFormGroup(triggerFormArray, i)">
              <mat-icon class="no-margin" [ngClass]="{'accent': true}">close</mat-icon>
            </button>
          }
        </div>
      </ng-container>
    </div>
  }
  <div class="bottom-section">
    <div aria-live="polite">
      @if (triggerFormArray.errors?.msError) {
        <mat-error class="mse-form-error caption bottom-hint">{{ triggerFormArray.errors?.msError }}</mat-error>
      }
    </div>
    <div class="left-margin">
      <button
        #addTriggerButton
        type="button"
        (click)="addTriggerFormGroup(triggerFormArray, triggerOptions)"
        mat-flat-button
        color="accent"
        class="button">
        {{ (formArrayName === actionNotificationTriggerForms.warningTriggers ? sysText.addWarningTrigger : sysText.addDueTrigger) | uppercase }}
      </button>
    </div>
  </div>

</div>